import { render } from "./ItemNotFound.vue?vue&type=template&id=4c327217"
import script from "./ItemNotFound.vue?vue&type=script&lang=ts"
export * from "./ItemNotFound.vue?vue&type=script&lang=ts"

import "./ItemNotFound.vue?vue&type=style&index=0&id=4c327217&lang=scss"
script.render = render

export default script